module.exports = __webpack_public_path__ + "static/sdk-ao-5ad3a88e9d63feb12f6a9c6e6a8a937b.mp4";